<template>
  <VueFinalModal
      class="flex justify-center items-center"
      content-class="modal2 flex flex-col max-w-xl p-4 bg-white dark:bg-gray-900 border dark:border-gray-700 rounded-lg space-y-2"
      @update:model-value="val => $emit('update:modelValue', val)"
    >
      <h3 class="text-xl">
        {{ title }}
      </h3>
      <hr/>
      <slot />
    </VueFinalModal>
</template>

<script>

import { VueFinalModal } from 'vue-final-modal';

export default {
  name: "modal",
  props: {
    title: {
      type: String,
      required: true
    },
  },
  emits: ['update:modelValue', 'confirm'],
  components: {
    VueFinalModal
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {
    updateModelValue(value) {
      console.log(this.$emit, value);
      //this.$emit('update:modelValue', value);
    },
    
    confirm() {
      console.log(this.$emit, 'condfrim');
      //this.$emit('confirm');
    }
  }
};
</script>

<style>
.modal2{
  max-height: 80%;
  overflow: auto;
  max-width: 800px;
  margin: 2em auto !important;
  border-radius: 11px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.flatpickr-calendar.static{
  left: 40px;
}
</style>
